module.exports = __webpack_public_path__ + "static/media/new-hampshire.d6a86e05.jpg";